import { Injectable } from '@jkhy/frontend-utils/di';
import {
    ChallengeGroupCompanyModelDto,
    ChallengeGroupDetailModelDto,
    ChallengeGroupsClient,
    RequestParams,
} from '@treasury/api/bo';
import { AuthenticationProfile } from './entities/authentication-profile.entity';
import { AuthenticationProfileDetail } from './entities/authentication-profile-detail.entity';

@Injectable()
export class AuthenticationProfileBoService {
    constructor(private readonly client: ChallengeGroupsClient) {}

    public async getProfiles(): Promise<AuthenticationProfile[]> {
        const response = await this.client.challengeGroupsGetAll();
        return response.data.map(dto => AuthenticationProfile.from(dto));
    }

    public async getProfileDetail(id: number): Promise<AuthenticationProfileDetail> {
        const response = await this.client.challengeGroupsGet(id);
        return AuthenticationProfileDetail.from(response.data as ChallengeGroupDetailModelDto);
    }

    public async getClonedProfileDetail(id: number): Promise<AuthenticationProfileDetail> {
        const response = await this.client.challengeGroupsGet(id, {
            query: { type: 'clone' },
        } as unknown as RequestParams);
        return AuthenticationProfileDetail.from(response.data as ChallengeGroupDetailModelDto);
    }

    public async createProfile(detail: AuthenticationProfileDetail): Promise<number> {
        const response = await this.client.challengeGroupsPost(
            detail.toDto() as ChallengeGroupDetailModelDto
        );
        return response.data;
    }

    public async updateProfile(detail: AuthenticationProfileDetail): Promise<number> {
        const response = await this.client.challengeGroupsPut2(
            detail.id,
            detail.toDto() as ChallengeGroupDetailModelDto
        );
        return response.data;
    }

    public async deleteProfile(id: number): Promise<boolean> {
        const response = await this.client.challengeGroupsDelete(id);
        return response.data;
    }

    public async getProfileCompanies(id: number): Promise<ChallengeGroupCompanyModelDto[]> {
        const response = await this.client.challengeGroupsGetGroupCOmpanies(id);
        return response.data;
    }
}
